// extracted by mini-css-extract-plugin
export default {"container":"eN-z","modal":"fN-z","dimensions":"gN-z","brandName":"hN-z","productName":"iN-z","labelValue":"jN-z","recipientEmail":"kN-z","recommendedFit":"lN-z","hiddenField":"mN-z"};